"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mfeVersionFallback = exports.getMfeUrl = exports.getCurrentUrlsMap = exports.getDefaultUrlsMap = exports.getMfeNames = exports.parseMfeToolkitFromCookies = exports.getCookieStringFromSettings = exports.getSettingsFromCookieString = void 0;
var getSettingsFromCookieString = function (cookieString) { return JSON.parse(cookieString || '{}'); };
exports.getSettingsFromCookieString = getSettingsFromCookieString;
var getCookieStringFromSettings = function (settings) { return JSON.stringify(settings || {}); };
exports.getCookieStringFromSettings = getCookieStringFromSettings;
var parseMfeToolkitFromCookies = function () {
    var result = {};
    var cookieHeader = document.cookie || '';
    cookieHeader.split(';').forEach(function (cookie) {
        var _a = cookie.split('='), name = _a[0], rest = _a.slice(1);
        if (name.trim() === 'MFE_TOOLKIT') {
            result = (0, exports.getSettingsFromCookieString)(rest.join('='));
        }
    });
    return result;
};
exports.parseMfeToolkitFromCookies = parseMfeToolkitFromCookies;
var getMfeNames = function () { return Object.keys(process.env)
    .filter(function (k) { return k.startsWith('REACT_APP_MFE_') && k.endsWith('_URL'); })
    .map(function (k) { return k.substr(14, k.length - 18); })
    .sort(); };
exports.getMfeNames = getMfeNames;
var getDefaultUrlsMap = function () {
    var names = (0, exports.getMfeNames)();
    return names.reduce(function (acc, name) {
        acc[name] = process.env["REACT_APP_MFE_".concat(name, "_URL")];
        return acc;
    }, {});
};
exports.getDefaultUrlsMap = getDefaultUrlsMap;
var getCurrentUrlsMap = function () { return (__assign(__assign({}, (0, exports.getDefaultUrlsMap)()), (0, exports.parseMfeToolkitFromCookies)())); };
exports.getCurrentUrlsMap = getCurrentUrlsMap;
var getMfeUrl = function (mfeName) {
    var settings = (0, exports.parseMfeToolkitFromCookies)();
    if (settings[mfeName]) {
        return settings[mfeName];
    }
    return process.env["REACT_APP_MFE_".concat(mfeName, "_URL")] || '';
};
exports.getMfeUrl = getMfeUrl;
var mfeVersionFallback = function (e) {
    // eslint-disable-next-line
    console.error(e);
    return Promise.resolve({ default: function () { return ({ name: 'N/A', version: 'N/A' }); } });
};
exports.mfeVersionFallback = mfeVersionFallback;
